// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2NdWU","title":"Info_title__3t51N","selects":"Info_selects__3W84u","requiredAsterisk":"Info_requiredAsterisk__25g94"};